import { environment } from "../../environments/environment";

export function generateUrl() {
    const subdomain = sessionStorage.getItem('subdomain');
    let chosenSubdomain = environment.subdomains[0];

    if (subdomain) {
        const filteredSubdomain = environment.subdomains.find(sub => sub === subdomain)
        if(filteredSubdomain) chosenSubdomain = filteredSubdomain;
    }
    return `${environment.protocol}${chosenSubdomain}.${environment.hubioIp}:${environment.gatewayPort}`;
}
export function generateIp() {
    const subdomain = sessionStorage.getItem('subdomain');
    let chosenSubdomain = environment.subdomains[0];

    if (subdomain) {
        const subdomainSearch = environment.subdomains.find(sub => sub === subdomain)
        if(subdomainSearch) chosenSubdomain = subdomainSearch;
    }
    return `${environment.protocol}${chosenSubdomain}.${environment.hubioIp}`
}

export function generateSaludIp() {
    const subdomain = sessionStorage.getItem('subdomain');
    
    let chosenSubdomain = environment.saludSubdomains[0];
    
    if (subdomain) {
        const removedSubdomain = subdomain.replace('dr', '')
        const subdomainSearch = environment.saludSubdomains.find(sub => sub === removedSubdomain)
        if(subdomainSearch) chosenSubdomain = subdomainSearch;
    }
    return `${environment.protocol}${chosenSubdomain}.${environment.hubioIp}`
}